import { Table } from 'components/tables/Table';
import { FunctionComponent, useMemo } from 'react';
import { adminAccountTableColumns } from './adminAccountTableColumns';
import { useNavigate } from 'react-router';
import { AdminAccount } from '../../../../../domain/account/interfaces/AdminAccount';
import { RequestStatus } from 'types/RequestStatus';

export const AdminAccountTable: FunctionComponent<{
	users: AdminAccount[];
	status: RequestStatus;
}> = ({ users, status }) => {
	const navigate = useNavigate();

	const columns = useMemo(
		() => [
			adminAccountTableColumns.fullName(),
			adminAccountTableColumns.email(),
			adminAccountTableColumns.roles(),
			adminAccountTableColumns.registered(),
		],
		[users],
	);

	return (
		<Table<AdminAccount>
			requestStatus={status}
			data={users}
			columns={columns}
			withPagination
			withSearch
			showRowCount
			initialSorting={[
				{
					id: 'registered',
					desc: true,
				},
			]}
			onRowClicked={(row) => navigate(`/accounts/admin-users/${row.id}`)}
		/>
	);
};
